module.exports = __webpack_public_path__ + "static/media/1.98a99ab1.jpg";